var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"d-flex justify-center align-center error--text"},[_vm._v(" Define you own template in a child component extending this one ")])
}
var staticRenderFns = []

export { render, staticRenderFns }